import { configureApiEntity } from '../adapter';
import { schema } from 'normalizr';

const operatorSchema = new schema.Entity('operator');

export const operators = configureApiEntity('OPERATORS', 'operators', operatorSchema);
